// import React from 'react';
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   StyleSheet,
//   Image,
// } from '@react-pdf/renderer';

// const styles = StyleSheet.create({
//   page: { padding: 30, fontSize: 12, fontFamily: 'Helvetica' },
//   header: { fontSize: 18, fontWeight: 'bold', marginBottom: 15 },
//   card: {
//     flexDirection: 'row',
//     padding: 10,
//     marginBottom: 10,
//     borderRadius: 6,
//     border: '1px solid #eee',
//     alignItems: 'center',
//   },
//   imageWrapper: {
//     width: 60,
//     height: 60,
//     borderRadius: 30,
//     overflow: 'hidden',
//     backgroundColor: '#ddd',
//   },
//   image: { width: '100%', height: '100%', objectFit: 'contain' },
//   content: { marginLeft: 15, flex: 1 },
//   name: { fontSize: 14, fontWeight: 'bold' },
//   info: { fontSize: 12, marginTop: 2 },
// });

// const InternationalPDFDocument = ({ type, leaders }) => (
//   <Document>
//     <Page size="A4" style={styles.page}>
//       <Text style={styles.header}>{type}</Text>
//       {leaders.map((leader) => (
//         <View key={leader.id} style={styles.card}>
//           <View style={styles.imageWrapper}>
//             {leader.image ? (
//               <Image
//                 src={{
//                   uri: leader.image,
//                   method: 'GET',
//                   headers: { 'Cache-Control': 'no-cache' },
//                   body: '',
//                 }}
//                 style={styles.image}
//               />
//             ) : (
//               <Text style={{ textAlign: 'center', marginTop: 20 }}>No Img</Text>
//             )}
//           </View>
//           <View style={styles.content}>
//             <Text style={styles.name}>{leader.name || 'Not Available'}</Text>
//             <Text style={styles.info}>{leader.designation}</Text>
//             <Text style={styles.info}>
//               <Text style={{ fontWeight: 'bold' }}>Year: </Text>
//               {leader.year}
//             </Text>
//             <Text style={styles.info}>{leader.club || 'Club not available'}</Text>
//           </View>
//         </View>
//       ))}
//     </Page>
//   </Document>
// );

// export default InternationalPDFDocument;




// import React from "react";
// import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";

// const styles = StyleSheet.create({
//   page: { padding: 30, fontSize: 12, fontFamily: "Helvetica" },
//   header: { fontSize: 18, fontWeight: "bold", marginBottom: 15 },
//   card: {
//     flexDirection: "row",
//     padding: 10,
//     marginBottom: 10,
//     borderRadius: 6,
//     border: "1px solid #eee",
//     alignItems: "center",
//   },
//   imageWrapper: {
//     width: 60,
//     height: 60,
//     borderRadius: 30,
//     overflow: "hidden",
//     backgroundColor: "#ddd",
//   },
//   image: { width: "100%", height: "100%", objectFit: "contain" },
//   content: { marginLeft: 15, flex: 1 },
//   name: { fontSize: 14, fontWeight: "bold" },
//   info: { fontSize: 12, marginTop: 2 },
// });

// const InternationalPDFDocument = ({ type, leaders }) => (
//   <Document>
//     <Page size="A4" style={styles.page}>
//       <Text style={styles.header}>{type}</Text>
//       {leaders.map((leader) => (
//         <View key={leader.id} style={styles.card}>
//           <View style={styles.imageWrapper}>
//             {leader.image ? (
//               <Image src={leader.image} style={styles.image} />
//             ) : (
//               <Text style={{ textAlign: "center", marginTop: 20 }}>No Img</Text>
//             )}
//           </View>
//           <View style={styles.content}>
//             <Text style={styles.name}>{leader.name || "Not Available"}</Text>
//             <Text style={styles.info}>{leader.designation || "Designation N/A"}</Text>
//             <Text style={styles.info}>
//               <Text style={{ fontWeight: "bold" }}>Year:</Text> {leader.year || "N/A"}
//             </Text>
//             <Text style={styles.info}>{leader.club || "Club not available"}</Text>
//           </View>
//         </View>
//       ))}
//     </Page>
//   </Document>
// );

// export default InternationalPDFDocument;


// import React from "react";
// import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";

// // PDF Styles
// const styles = StyleSheet.create({
//   page: {
//     padding: 30,
//     fontSize: 12,
//     fontFamily: "Helvetica",
//   },
//   header: {
//     fontSize: 18,
//     fontWeight: "bold",
//     marginBottom: 15,
//   },
//   card: {
//     flexDirection: "row",
//     padding: 10,
//     marginBottom: 10,
//     borderRadius: 6,
//     border: "1px solid #eee",
//     alignItems: "center",
//   },
//   imageWrapper: {
//     width: 60,
//     height: 60,
//     borderRadius: 30,
//     overflow: "hidden",
//     backgroundColor: "#ddd",
//   },
//   image: {
//     width: "100%",
//     height: "100%",
//     objectFit: "contain",
//   },
//   content: {
//     marginLeft: 15,
//     flex: 1,
//   },
//   name: {
//     fontSize: 14,
//     fontWeight: "bold",
//   },
//   info: {
//     fontSize: 12,
//     marginTop: 2,
//   },
// });

// // Split leaders into pages of 6
// const paginate = (array, pageSize = 6) => {
//   const pages = [];
//   for (let i = 0; i < array.length; i += pageSize) {
//     pages.push(array.slice(i, i + pageSize));
//   }
//   return pages;
// };

// const InternationalPDFDocument = ({ type, leaders }) => {
//   const paginated = paginate(leaders);

//   return (
//     <Document>
//       {paginated.map((pageLeaders, i) => (
//         <Page key={i} size="A4" style={styles.page}>
//           <Text style={styles.header}>{type} – Page {i + 1}</Text>
//           {pageLeaders.map((leader, index) => (
//             <View key={index} style={styles.card}>
//               <View style={styles.imageWrapper}>
//                 {leader.image ? (
//                   <Image src={leader.image} style={styles.image} />
//                 ) : (
//                   <Text>No Img</Text>
//                 )}
//               </View>
//               <View style={styles.content}>
//                 <Text style={styles.name}>{leader.name || "Not Available"}</Text>
//                 <Text style={styles.info}>{leader.designation || "N/A"}</Text>
//                 <Text style={styles.info}><Text style={{ fontWeight: "bold" }}>Year:</Text> {leader.year || "N/A"}</Text>
//                 <Text style={styles.info}>{leader.club || "Club not available"}</Text>
//               </View>
//             </View>
//           ))}
//         </Page>
//       ))}
//     </Document>
//   );
// };

// export default InternationalPDFDocument;


// InternationalPDFDocument.jsx
import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  Font,
} from '@react-pdf/renderer';

// Optional: Register a font if you want
// Font.register({ family: 'Open Sans', src: 'https://fonts.googleapis.com/css2?family=Open+Sans&display=swap' });

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
  },
  header: {
    fontSize: 18,
    marginBottom: 20,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  leaderContainer: {
    flexDirection: 'row',
    marginBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#ddd',
    borderBottomStyle: 'solid',
    paddingBottom: 10,
  },
  image: {
    width: 60,
    height: 80,
    marginRight: 10,
    objectFit: 'contain',
  },
  content: {
    flex: 1,
  },
  name: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  designation: {
    fontSize: 12,
    marginTop: 4,
  },
  year: {
    fontSize: 12,
    marginTop: 2,
  },
  club: {
    fontSize: 11,
    marginTop: 6,
    fontStyle: 'italic',
    color: '#007bff',
  },
});

const InternationalPDFDocument = ({ type, leaders }) => (
  <Document>
    <Page style={styles.page}>
      <Text style={styles.header}>International Leaders - {type}</Text>

      {leaders.map((leader, index) => (
        <View key={index} style={styles.leaderContainer}>
          {leader.image ? (
            <Image src={leader.image} style={styles.image} />
          ) : (
            <View
              style={{
                ...styles.image,
                backgroundColor: '#ccc',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Text>No Image</Text>
            </View>
          )}

          <View style={styles.content}>
            <Text style={styles.name}>{leader.name || "Not Available"}</Text>
            <Text style={styles.designation}>{leader.designation}</Text>
            <Text style={styles.year}>Year: {leader.year}</Text>
            <Text style={styles.club}>{leader.club || "Club not available"}</Text>
          </View>
        </View>
      ))}
    </Page>
  </Document>
);

export default InternationalPDFDocument;
